import script from "./HelpGuide.vue?vue&type=script&setup=true&lang=ts"
export * from "./HelpGuide.vue?vue&type=script&setup=true&lang=ts"

import "./HelpGuide.vue?vue&type=style&index=0&id=7beb80bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7beb80bc"]])

export default __exports__